<template>
  <div class="animated">
    <b-card>
      <div slot="header"><i class="fab fa-youtube"></i> Youtube</div>

      <b-button
        class="youtubebutton"
        v-on:click="openCreateModal"
        :disabled="!canAdd"
      >
        <i class="fab fa-youtube"></i> Add Youtube Channel
      </b-button>
      <br /> <br />
      <div v-if="!isPremium" class="quota-card" :class="{ 'quota-card--full': !canAdd }">
        <div class="quota-card__header">
          <span class="quota-card__count">
            <strong>{{ notifications.length }}</strong>
            <span class="quota-card__sep">/</span>
            <span class="quota-card__limit">{{ channelLimit }}</span>
            channels used
          </span>
          <span class="quota-card__premium-hint">
            Premium: {{ youtubePremiumLimit }} channels
          </span>
        </div>
        <div class="quota-card__bar">
          <div
            class="quota-card__bar-fill"
            :style="{ width: Math.min(100, (notifications.length / channelLimit) * 100) + '%' }"
          ></div>
        </div>
        <a href="/get-premium" class="quota-card__cta">
          <i class="fas fa-crown"></i>
          {{ canAdd ? "Track up to " + youtubePremiumLimit + " channels with Premium" : "Upgrade to Premium to track " + youtubePremiumLimit + " channels" }}
          <i class="fas fa-arrow-right"></i>
        </a>
      </div>

      <hr />
      <v-client-table
        :columns="columns"
        :data="notifications"
        :options="options"
        :theme="theme"
        id="dataTable"
        style="width: 100%"
      >
        <p slot="youtube" slot-scope="props" block>
          {{ props.row.youtube_name }}
        </p>
        <p slot="channel" slot-scope="props" block>
          #{{ channel_from_id(props.row.channel_id).name }}
        </p>
        <b-container
          slot="options"
          class="d-md-inline-block"
          slot-scope="props"
        >
          <b-row>
            <b-col>
              <b-button block variant="primary" v-on:click="openEdit(props.row)"
                >Edit</b-button
              >
            </b-col>
            <b-col>
              <b-button
                block
                variant="outline-danger"
                v-on:click="deleteYoutubeAlert(props.row)"
              >
                Delete
                <i class="icon-trash"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </v-client-table>
    </b-card>
    <b-modal size="md" v-model="createModal" :no-enforce-focus="true">
      <template slot="modal-title">
        <h4 class="smalltitle">
          <i class="fab fa-youtube"></i> Add Youtube
          Channel
        </h4>
      </template>
      <label for="ajax" class="teenytinytitle">Youtube link</label>

      <b-form-input
                show="true"
                :maxlength="200"
                v-model="link"
                type="text"
                placeholder="Enter youtube channel or video link"
              ></b-form-input>


      <label for="discord_channel_select" class="teenytinytitle mt-4"
        >Channel</label
      >
      <multiselect
        v-model="discordChannel"
        id="discord_channel_select"
        track-by="id"
        label="name"
        placeholder="Please select a channel"
        open-direction="bottom"
        :searchable="true"
        :clear-on-select="false"
        :close-on-select="true"
        :max-height="600"
        :show-no-results="false"
        :hide-selected="false"
        :options="groupedChannels"
        :allow-empty="false"
        group-values="channels"
        group-label="category"
        :group-select="false"
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <font-awesome-icon style="color:#72767d" icon="hashtag" />
            <span class="option__title ml-2">{{ props.option.name }}</span>
          </span>
        </template>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">
              <font-awesome-icon
                style="color:#72767d"
                :icon="!props.option['$isLabel'] ? 'hashtag' : 'chevron-down'"
              />
              {{ props.option.name || props.option.$groupLabel.name }}
            </span>
          </div>
        </template>
      </multiselect>
      <label for="announcement_message" class="teenytinytitle mt-4"
        >Announcement message</label
      >

      <b-input-group>
        <b-form-textarea
          :maxlength="2000"
          rows="6"
          type="text"
          placeholder=" {author} just uploaded a video, go check it out! {link} "
          class="col-12"
          v-model="announcementMessage"
          id="announcement_message"
        ></b-form-textarea>
      </b-input-group>
      <div slot="modal-footer" class="w-100">
        <b-container
          fluid
          class="text-light text-center"
          style="padding-right:0px;"
        >
          <b-row class="mr-auto">
            <b-col cols="auto" class="mr-auto p-2"></b-col>
            <b-col cols="auto" class="p-2">
              <b-button
                variant="ghost-secondary"
                v-on:click="createModal = false"
                >Cancel</b-button
              >
            </b-col>
            <b-col cols="auto" class="p-2">
              <b-button
                class="youtubebutton"
                v-on:click="addYoutubeAlert"
                :disabled="!discordChannel || !link"
                >Add</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal size="md" v-model="editModal" :no-enforce-focus="true">
      <template slot="modal-title">
        <h4 class="smalltitle">
          <i class="fab fa-youtube"></i> Edit
          Youtube Alert
        </h4>
      </template>
      <h4 class="smalltitle">{{ youtubeChannelName }}</h4>
      <label for="discord_channel_select" class="teenytinytitle mt-4"
        >Channel</label
      >
      <multiselect
        v-model="discordChannel"
        id="discord_channel_select"
        track-by="id"
        label="name"
        placeholder="Please select a channel"
        open-direction="bottom"
        :clear-on-select="false"
        :close-on-select="true"
        :max-height="600"
        :show-no-results="false"
        :hide-selected="false"
        :options="groupedChannels"
        :allow-empty="false"
        group-values="channels"
        group-label="category"
        :group-select="false"
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <font-awesome-icon style="color:#72767d" icon="hashtag" />
            <span class="option__title ml-2">{{ props.option.name }}</span>
          </span>
        </template>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">
              <font-awesome-icon
                style="color:#72767d"
                :icon="!props.option['$isLabel'] ? 'hashtag' : 'chevron-down'"
              />
              {{ props.option.name || props.option.$groupLabel.name }}
            </span>
          </div>
        </template>
      </multiselect>

      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <font-awesome-icon style="color:#72767d" icon="hashtag" />
          <span class="option__title ml-2">{{ props.option.name }}</span>
        </span>
      </template>
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">
            <font-awesome-icon style="color:#72767d" icon="hashtag" />
            {{ props.option.name }}
          </span>
        </div>
      </template>
      <label for="announcement_message" class="teenytinytitle mt-4"
        >Announcement message</label
      >

      <b-input-group>
        <b-form-textarea
          :maxlength="2000"
          rows="6"
          type="text"
          placeholder="{author} just uploaded a video, go check it out! {link}"
          class="col-12"
          v-model="announcementMessage"
          id="announcement_message"
        ></b-form-textarea>
      </b-input-group>
      <div slot="modal-footer" class="w-100">
        <b-container
          fluid
          class="text-light text-center"
          style="padding-right:0px;"
        >
          <b-row class="mr-auto">
            <b-col cols="auto" class="mr-auto p-2"></b-col>
            <b-col cols="auto" class="p-2">
              <b-button variant="ghost-secondary" v-on:click="editModal = false"
                >Cancel</b-button
              >
            </b-col>
            <b-col cols="auto" class="p-2">
              <b-button
                class="youtubebutton"
                v-on:click="editYoutubeAlert"
                :disabled="!discordChannel"
                >Save</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { Switch as cSwitch } from "@coreui/vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { ClientTable, Event } from "vue-tables-2";
import Multiselect from "vue-multiselect";
import debounce from "lodash/debounce";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const toast_options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, toast_options);
Vue.use(ClientTable);

export default {
  name: "DataTable",
  components: {
    Event,
    ClientTable,
    cSwitch,
    Multiselect
  },
  notifications: {
    added_alert: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Tag created"
    },
    failed_alert: {
      type: VueNotifications.types.error,
      title: "Error!",
      message: "uh oh!! something went wrong"
    },
    added_trigger: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Trigger created"
    },
    edited_tag: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Tag edited"
    },
    deleted_tag: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Tag deleted"
    },
    fill_in_fields: {
      type: VueNotifications.types.warn,
      title: "Uh oh",
      message: "Please fill in all fields"
    },
    no_spaces_thank_you: {
      type: VueNotifications.types.warn,
      title: "Bad tag",
      message:
        "Tags don't really work when they have spaces added, consider replacing them with dashes or underscores"
    }
  },
  data: function() {
    return {
      columns: ["youtube_name", "channel", "options"],
      data: [],
      createModal: false,
      isPremium: false,
      editModal: false,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      isLoading: false,
      link: "",
      discordChannel: null,
      twitchChannels: [],
      selectedRow: null,
      youtubeNonPremiumLimit: 1,
      youtubePremiumLimit: 20,
      notifications: [],
      channels: [],
      announcementMessage: "",
      youtubeChannelName: "",
      youtubeId: "",
      options: {
        filterByColumn: true,
        texts: {
          filter: "Filter",
          filterBy: "Filter by {column}"
        },
        sortable: ["youtube_name", "channel", "options"],
        headings: {
          youtube_name: "Youtube channel"
        },
        filterable: ["youtube_name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        },
        childRow: false,
        highlightMatches: true
      },
      theme: "bootstrap4"
    };
  },
  methods: {
    channel_from_id(id) {
      return (
        this.channels.find(x => x.id == id) || {
          name: "unknown channel (deleted?)"
        }
      );
    },
    openEdit(row) {
      this.selectedRow = row;
      this.discordChannel = this.channel_from_id(row.channel_id);
      this.announcementMessage = row.fmt;
      this.youtubeChannelName = row.youtube_name;
      this.youtubeId = row.youtube_id;
      this.editModal = true;
    },
    async addYoutubeAlert() {
      await this.axios.put(
        "/api/v1/servers/" + this.$route.params.guild_id + "/youtube",
        {
          add_stream: true,
          youtuber: this.link,
          channel_id: this.discordChannel.id,
          announce_message: this.announcementMessage
        }
      )
      .then(r => {
          this.createModal = false;
           if(r.status === 200){
           this.added_alert({message: "Successfully added new alert!"})
           setTimeout(
            () =>
              this.axios
                .get(
                  "/api/v1/servers/" + this.$route.params.guild_id + "/youtube"
                )
                .then(resp => {
                  const youtubeLimits = (resp.data && resp.data.youtubeLimits) || {};
                  this.notifications = (resp.data && resp.data.subscriptionList) || [];
                  this.isPremium = resp.data && resp.data.isPremium === 1;
                  this.youtubePremiumLimit = youtubeLimits.VIP;
                  this.youtubeNonPremiumLimit = youtubeLimits.NON_VIP;
                  this.$Progress.finish();
                }),
            2000
          );


           }
        })
        .catch(error => {
              if(error.response.status==400)
                  {
                  this.failed_alert({message: error.response.data.msg})
                  }
              else{
              this.failed_alert({message: "Uh oh!! Something went wrong, Please try again later"})
              }
          });
    },
    async editYoutubeAlert() {
      await this.axios.patch(
        "/api/v1/servers/" + this.$route.params.guild_id + "/youtube",
        {
          youtube_id: this.youtubeId,
          youtube_name: this.youtubeChannelName,
          channel_id: this.discordChannel.id,
          announce_message: this.announcementMessage
        }
      )
      .then(r => {
          this.editModal = false;
           if(r.status === 200){
           this.added_alert({message: "Successfully edited!"})
           }
        })
        .catch(error => {
        this.editModal = false;
              if(error.response.status==400)
                  {
                  this.failed_alert({message: error.response.data.msg})
                  }
              else{
              this.failed_alert({message: "Uh oh!! Something went wrong, Please try again later"})
              }
          });

      for (let i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].youtube_id == this.youtubeId) {
          this.notifications[i].channel_id = this.discordChannel.id;
          this.notifications[i].fmt = this.announcementMessage;
          break;
        }
      }
    },
    async deleteYoutubeAlert(row) {
      await this.axios.delete(
        "/api/v1/servers/" +
          this.$route.params.guild_id +
          "/youtube/" +
          row.youtube_id
      ).then(r => {
           if(r.status === 200){
           this.added_alert({message: "Successfully Deleted!"})
           }
        });
      for (let i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].youtube_id == row.youtube_id) {
          this.notifications.splice(i, 1);
        }
      }
    },
    openCreateModal() {
      this.selectedRow = null;
      this.discordChannel = null;
      this.announcementMessage = "";
      this.createModal = true;
      this.link="";
    },
  },
  computed: {
    channelLimit() {
      return this.isPremium ? this.youtubePremiumLimit : this.youtubeNonPremiumLimit;
    },
    canAdd() {
      return this.notifications.length < this.channelLimit;
    },
    groupedChannels() {
      let groups = [
        {
          category: {
            id: null,
            name: "Uncategorized"
          },
          channels: []
        }
      ];
      let currentGroup = groups[0];
      for (let chn of this.channels.sort((a, b) => a.position - b.position)) {
        if (chn.type === 4) {
          currentGroup = { category: chn, channels: [] };
          groups.push(currentGroup);
        }
      }
      for (let chn of this.channels.sort((a, b) => a.position - b.position)) {
        if (chn.type === 4) {
          continue;
        }
        currentGroup = groups.find(g => {
          return g.category.id == chn.parent_id;
        });
        if (!currentGroup) {
          continue;
        }
        currentGroup.channels.push(chn);
      }
      return groups;
    },
    sortedChannels() {
      return this.twitchChannels.sort((a, b) => {
        if (a.partner && !b.partner) {
          return -1;
        }
        if (b.partner && !a.partner) {
          return 1;
        }
        return a.display_name > b.display_name;
      });
    }
  },
  created() {
    this.$Progress.start();
    const db = this.axios.get(
      "/api/v1/servers/" + this.$route.params.guild_id + "/youtube"
    );
    const chns = this.axios.get(
      "/api/v1/servers/" +
        this.$route.params.guild_id +
        "/channels?categories=true"
    );
    this.axios.all([db, chns]).then(
      this.axios.spread((...responses) => {
        const resp = responses[0];
        const channels = responses[1];
        const youtubeLimits = (resp.data && resp.data.youtubeLimits) || {};
        this.notifications = (resp.data && resp.data.subscriptionList) || [];
        this.isPremium = resp.data && resp.data.isPremium === 1;
        this.youtubePremiumLimit = youtubeLimits.VIP;
        this.youtubeNonPremiumLimit = youtubeLimits.NON_VIP;
        this.channels = channels.data;
        this.$Progress.finish();
      })
    );
  }
};
</script>
<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
<style scoped>
.danger-text {
  color: #ff0000;
}
.youtubebutton {
  background-color: #c4302b;
  border-color: #c4302b;
}
.youtubebutton:active {
  background-color: #c4302b !important;
  border-color: #c4302b !important;
}
.youtubebutton:hover {
  background-color: #9e1e19;
  border-color: #9e1e19;
}

.quota-card {
  background: rgba(248, 203, 0, 0.06);
  border: 1px solid rgba(248, 203, 0, 0.25);
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 8px;
}
.quota-card--full {
  background: rgba(248, 203, 0, 0.12);
  border-color: rgba(248, 203, 0, 0.5);
}
.quota-card__header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #d8d6e0;
}
.quota-card__count strong {
  font-size: 18px;
  color: #fff;
  font-weight: 700;
}
.quota-card__sep {
  margin: 0 2px;
  color: #888;
}
.quota-card__limit {
  color: #fff;
  font-weight: 600;
}
.quota-card__premium-hint {
  font-size: 12px;
  color: #f8cb00;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.quota-card__bar {
  height: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 12px;
}
.quota-card__bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #f8cb00, #ff9800);
  border-radius: 999px;
  transition: width 0.3s ease;
}
.quota-card__cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #f8cb00;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}
.quota-card__cta:hover {
  color: #ffd83d;
  text-decoration: none;
}
.quota-card__cta i:first-child {
  font-size: 13px;
}
.quota-card__cta i:last-child {
  font-size: 11px;
  transition: transform 0.2s ease;
}
.quota-card__cta:hover i:last-child {
  transform: translateX(3px);
}
</style>
